import React, { useEffect } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import WelcomeVideo from "./assets/mercy.mp4"; // Correct path for your video file

const WelcomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100vh;
  background-color: #000; /* Black background */
  color: #fff; /* White text */
  font-family: "Arial, sans-serif";
`;

const TopText = styled(motion.h1)`
  font-size: 2.5rem;
  color: #ff0000; /* Bright red */
  margin-top: 20px;
`;

const VideoContainer = styled(motion.div)`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const VideoStyled = styled.video`
  width: 80%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(255, 255, 255, 0.3);
`;

const BottomText = styled(motion.h1)`
  font-size: 2rem;
  color: #ff0000; /* Bright red */
  margin-bottom: 20px;
`;

const Welcome = ({ onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 8000); // 5 seconds
    return () => clearTimeout(timer); // Cleanup timer
  }, [onComplete]);

  return (
    <WelcomeContainer>
      <TopText
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        All Glory to God
      </TopText>

      <VideoContainer
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
      >
        <VideoStyled
          src={WelcomeVideo}
          autoPlay
          loop
          muted
          alt="Welcome Video"
        />
      </VideoContainer>

      <BottomText
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        Mercy Hands
      </BottomText>
    </WelcomeContainer>
  );
};

export default Welcome;
